<template>
  <div
    :class="{ 'scrollable--x': axis === 'x', 'scrollable--y': axis === 'y' }"
    class="scrollable"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
// const props = defineProps({
defineProps({
  axis: {
    type: String,
    default: '',
  },
  // enabled: { // change to hide option
  //   type: Boolean,
  //   default: false
  // }
})

// const direction = props.axis
</script>

<style>
@import url("~layers/app/components/Ui/Scrollable.css");
</style>
